import { getApiRequest } from '../helpers/apiHelper'
import { displayNotification } from './notificationsActions'
export const FETCH_LOANHISTORY = 'FETCH_LOANHISTORY'
export const FETCH_LOANHISTORY_SUCCESS = 'FETCH_LOANHISTORY_SUCCESS'
export const FETCH_LOANHISTORY_FAILURE = 'FETCH_LOANHISTORY_FAILURE'
export const FETCH_LOANTRANSACTIONS = 'FETCH_LOANTRANSACTIONS'
export const FETCH_LOANTRANSACTIONS_SUCCESS = 'FETCH_LOANTRANSACTIONS_SUCCESS'
export const FETCH_LOANTRANSACTIONS_FAILURE = 'FETCH_LOANTRANSACTIONS_FAILURE'

export const fetchLoanHistory = (loanId) => (dispatch) => {
  dispatch({ type: FETCH_LOANHISTORY })
  return getApiRequest(`loans/${loanId}`)
    .then((response) => {
      const decision_history =
        response.data.payload.decision_history.decision_history
      dispatch({ type: FETCH_LOANHISTORY_SUCCESS, payload: decision_history })
    })
    .catch((error) => {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : 'Something went wrong'
      dispatch({
        type: FETCH_LOANHISTORY_FAILURE,
      })
      dispatch(displayNotification(`${errorMessage}`, 'error'))
    })
}

export const fetchLoanTransactions = (loanId) => (dispatch) => {
  dispatch({ type: FETCH_LOANTRANSACTIONS })
  return getApiRequest(`loans/${loanId}/transactions`)
    .then((response) => {
      const loan_transactions = response.data.transactions
      dispatch({
        type: FETCH_LOANTRANSACTIONS_SUCCESS,
        payload: loan_transactions,
      })
    })
    .catch((error) => {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : 'Something went wrong'
      dispatch({
        type: FETCH_LOANTRANSACTIONS_FAILURE,
      })
      dispatch(displayNotification(`${errorMessage}`, 'error'))
    })
}
